import {Campaign} from "../../../models/campaign.model";
import {RouteParams, Router} from "angular2/router";
import {AlertService} from "../../common/alerts/alert.service";
import {ViewChild} from "angular2/core";
import {CampaignService} from "../campaign.service";
import {ProductService} from "../../products/product.service";
import {TranslateService} from "ng2-translate/ng2-translate";
export abstract class AbstractCampaignFormComponent {
    model:Campaign;
    @ViewChild('countrySelect') countrySelect;

    constructor(protected _params:RouteParams, protected _campaignService:CampaignService,
                protected _productService:ProductService, protected _alert_service:AlertService,
                protected _router:Router, protected _translateService:TranslateService) {
        this.model = new Campaign({});
    }

    setSelectedCountryName() {
        var selectCountryEl = jQuery(this.countrySelect.valueAccessor._elementRef.nativeElement).find("option:selected");
        this.model.countryName = selectCountryEl.text();
    }

    redirect() {
        this._router.navigate(['Campaigns']);
    }

    onSubmit() {
        this.model.setValue();
        this.setSelectedCountryName();
        this.submitCallback();
    }

    submitCallback() {
    }
}